<template>
  <div class="pay invoice">
		<div class="box">
			<el-row class="content">
				<el-col :span="12" class="txt">
					<h4 class="title">支付开票</h4>
					<p class="desc">支付开票指的是用户在扫码支付后，在支付成功的页面中直接申请开票， 不用商家任何操作。</p>
					<p class="desc tip">适用于餐饮、酒店、药店、停车场、水果店、花店等门店类</p>
				</el-col>
				<el-col :span="12" class="invoicing-box">
					<div class="invoicing-img"><img width="100%" src="../assets/product/pay.png" alt="" srcset=""></div>
				</el-col>
			</el-row>
		</div>

		<div class="box instructions">
			<div class="content">
				<h3 class="tit">使用方法</h3>
				<el-row class="img-list" v-if="!isMobile">
					<el-col :span="6" v-for="item in instructionsList" :key="item.id">
						<div class="img">
							<img :src="item.url" alt="">
						</div>
						<p class="desc"><span class="num">{{ item.num }}</span>{{ item.title }}</p>
					</el-col>
				</el-row>

        <el-carousel trigger="click" v-else ref="carousel">
          <el-carousel-item v-for="item in instructionsList" :key="item.id">
            <img style="height:90%;" :src="item.url"/>
            <p class="img-info"><span class="num">{{ item.num }}</span>{{ item.title }}</p>
          </el-carousel-item>
        </el-carousel>

			</div>
		</div>

		<div class="box process">
			<div class="content">
				<h3 class="title">接入流程</h3>
				<ul class="process-list">
					<li class="lis">
						<div class="img-box">
							<img class="img1" src="../assets/svg/support-hotline.svg" alt="">
						</div>
						<div class="desc">
							<p>咨询电话：</p>
							<p>张经理 16625500010</p>
						</div>
					</li>
					<li class="arrow-box">
						<img class="arrow" src="../assets/svg/arrow-right.svg" alt="">
					</li>
					<li class="lis">
						<div class="img-box">
							<img class="img2" src="../assets/svg/platform-regist.svg" alt="">
						</div>
						<div class="desc">
							<p>商家在pc平台注册</p>
						</div>
					</li>
					<li  class="arrow-box">
						<img class="arrow" src="../assets/svg/arrow-right.svg" alt="">
					</li>
					<li class="lis">
						<div class="img-box">
							<img class="img3" src="../assets/svg/examination-passed.svg" alt="">
						</div>
						<div class="desc">
							<p>审核通过</p>
						</div>
					</li>
					<li class="arrow-box">
						<img class="arrow" src="../assets/svg/arrow-right.svg" alt="">
					</li>
					<li class="lis">
						<div class="img-box">
							<img class="img4" src="../assets/svg/invoicing.svg" alt="">
						</div>
						<div class="desc">
							<p>开具发票</p>
						</div>
					</li>
				</ul>
				<el-button plain class="btn btn-xm" @click="handleToMerchant">马上试用</el-button>
			</div>
		</div>

  </div>
</template>

<script>
const img1 = require('@/assets/product/pay1.png')
const img2 = require('@/assets/product/pay2.png')
const img3 = require('@/assets/product/pay3.png')
const img4 = require('@/assets/product/pay4.png')
export default {
	name: 'Pay',
	data() {
		return {
			instructionsList: [
				{
					id: '1',
					num: '01',
					title: '支付',
					url: img1
				}, {
					id: '2',
					num: '02',
					title: '申请开票',
					url: img2
				},
				{
					id: '3',
					num: '03',
					title: '提交开票信息',
					url: img3
				}, {
					id: '4',
					num: '04',
					title: '开票成功',
					url: img4
				}
			],
			isMobile: false
		}
	},
	mounted() {
		this.isMobile = this.UA().mobile
	},
	methods: {
		handleToMerchant() {
			window.open('https://shanghu.jupiaotong.cn/')
		}
	}
}
</script>

<style lang="less" scoped>
.pay {
	.img-list {
		background: #fff;
		// height: 6.78rem;
		padding: .8rem 0 .6rem;
		display: flex;
		justify-content: center;
		.desc {
			margin-top: .2rem;
		}
		.num {
			font-size: .3rem;
			font-family: Arial Narrow;
			font-weight: 400;
			font-style: italic;
			color:rgba(183,28,34,1);
			margin-right: .1rem;
		}
		.img {
			padding: .1rem .2rem;
			height: 100%;
			img {
				width: 100%;
				height: 100%;
			}
		}
		/deep/ .el-col {
			display: flex;
			flex-direction: column;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Pay.vue